import PropTypes from "prop-types";
import React, { useState, useEffect }  from "react";
import { Collapse } from "reactstrap";
import { Link, withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import LiveTimer from "helpers/live_timer"
import cookieHelper from "helpers/getCookieData";

const Navbar = props => {

  const tokenData = cookieHelper.getCookie("_vslaccdt")? JSON.parse((cookieHelper.getCookie("_vslaccdt"))): null;

  if(tokenData?.role == 'client'){
    return '';
  }

  return (
    <React.Fragment>
      <div className="topnav">
        <div className="container-fluid">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav">
                <li className="nav-item">
                  <Link className="nav-link" to="/dashboard"><i className="bx bx-home-circle me-2"></i>{props.t("Dashboard")} {props.menuOpen}</Link>
                </li>
                <li className="nav-item">
                  <Link to="/shipments" className="nav-link"><i className="bx bx-user me-2"></i> {props.t("Shipment")} </Link>
                </li>
                <li className="nav-item">
                  <Link to="/reports" className="nav-link" > <i className="bx bx-layer me-2"></i> {props.t("Reports")}</Link>
                </li>
                <li className="nav-item">
                  <Link to="/settings" className="nav-link" > <i className="bx bx-chip me-2"></i> {props.t("Settings")}</Link>
                </li>
              </ul>
              <span className="d-sm-block d-md-none">
                <LiveTimer ism={true}/>
              </span>
            </Collapse>
            <span className="d-none d-md-block">
              <div className="d-flex text-white">
                <ul className="navbar-nav">
                  <li className="nav-item">
                    <Link to="/shedule" target="_blank" rel="noopener noreferrer" className="nav-link"> <i className="bx bx-chip me-2"></i> {props.t("Update Tracking")}</Link>
                  </li>
                </ul>

                {/* <button onClick={() => {
                  window.open("https://api.expressfly.org/api/v1/track/track/all", "_blank");
                }} className="me-4 btn btn-primary"><i className="fas fa-weight" /></button> */}
                <div style={{width: '160px'}}>
                  <LiveTimer ism={false}/>
                </div>
              </div>
            </span>
          </nav>
        </div>
      </div>
    </React.Fragment>
  );
};

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
};

const mapStatetoProps = state => {
  const { leftMenu } = state.Layout;
  return { leftMenu };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(Navbar))
);
